import { useEventCallback } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@issuemanager/apps/client/components';
import { useStartAction } from '@issuemanager/client/features/issues';
import {
  useAllMutations,
  useMonitorStartActionSubmit,
} from '@issuemanager/apps/client/hooks';
import { useIssueOutletContext } from '../hooks/useIssueOutletContext';

interface Props {
  id: string;
}

export function ActionDetailsStartButton({ id }: Props) {
  const { code: issueCode } = useIssueOutletContext();
  const startAction = useStartAction({ issueCode });

  const { t } = useTranslation('action');

  const handleStartAction = useEventCallback(async () => {
    await startAction.mutateAsync({ actionId: id });
  });

  const monitorStartActionSubmit = useMonitorStartActionSubmit();

  useAllMutations({
    mutations: [startAction],
    onStart: () => {
      monitorStartActionSubmit.start();
    },
    onSuccess: () => {
      monitorStartActionSubmit.stop();
    },
    onError: () => {
      monitorStartActionSubmit.error();
    },
  });

  return (
    <LoadingButton
      onClick={handleStartAction}
      loading={startAction.isPending}
      variant='contained'
      data-testid='change-status-button'
    >
      {startAction.isPending
        ? t('view.details.buttons.starting')
        : t('view.details.buttons.start')}
    </LoadingButton>
  );
}
